import { css } from "styled-components";

const cardStyle = css`
	margin: 10px 0 !important;
	/* box-shadow: 2px 2px 2px 2px rgb(0 0 0 / 25%); */
	border-radius: 10px;
	padding: 15px;
	border: 1px solid var(--border-color);
`;

export const styleAddItemButton = css`
	position: absolute;
	right: 70px;
	top: -29.5px; 
	@media(max-width: 720px){
		top: -28.5px; 
	}
`;

export default cardStyle;
